import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { ABOUT_IMAGE } from "../../lib/constants";
import { useReveal } from "../../hooks/useReveal";

export const About = () => {
  const { t } = useLanguage();
  const ref = useReveal();

  return (
    <section
      id="about"
      data-testid="about-section"
      className="bg-bg-alt py-16 md:py-20"
    >
      <div
        ref={ref}
        className="reveal max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20 items-center"
      >
        <div className="img-hover relative aspect-[4/5] overflow-hidden">
          <img
            src={ABOUT_IMAGE}
            alt="The photographer at work"
            className="w-full h-full object-cover"
          />
          <div className="absolute bottom-6 left-6 bg-white/90 backdrop-blur-md px-5 py-3">
            <p className="overline">{t.about.overline}</p>
          </div>
        </div>

        <div>
          <p className="overline">{t.about.overline}</p>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-accent-dark mt-4 tracking-tight font-light leading-[1.1]">
            {t.about.title}
          </h2>
          <span className="hairline mt-8 mb-6" />
          <div className="space-y-5 text-text-muted text-base md:text-lg leading-relaxed">
            <p>{t.about.paragraph1}</p>
            <p>{t.about.paragraph2}</p>
            <p>{t.about.paragraph3}</p>
          </div>

          <div className="mt-10 grid grid-cols-3 gap-4 border-t border-border-soft pt-8">
            {t.about.stats.map((s, i) => (
              <div key={i} data-testid={`about-stat-${i}`}>
                <p className="font-serif text-3xl md:text-4xl text-gold">
                  {s.value}
                </p>
                <p className="text-xs tracking-[0.15em] uppercase text-text-muted mt-2">
                  {s.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
